const QUEUE_KEY = 'furryai_offline_queue';

export function queueAction(type, payload) {
  const queue = getQueue();
  queue.push({
    id: Date.now(),
    type,
    payload,
    timestamp: new Date().toISOString(),
    attempts: 0
  });
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  console.log(`[Offline Queue] Queued: ${type}`);
}

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function clearQueue() {
  localStorage.setItem(QUEUE_KEY, JSON.stringify([]));
}

export function removeFromQueue(id) {
  const queue = getQueue().filter((item) => item.id !== id);
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

export async function flushQueue(apiClient) {
  const queue = getQueue();
  if (queue.length === 0) return;
  console.log(`[Offline Queue] Flushing ${queue.length} queued actions...`);
  for (const item of queue) {
    try {
      if (item.type === 'RECORD_VACCINATION') {
        const { dogId, ...data } = item.payload;
        await apiClient.post(`/dogs/${dogId}/vaccinations`, data);
        removeFromQueue(item.id);
        console.log(`[Offline Queue] Synced: ${item.type}`);
      }
    } catch (err) {
      console.error(`[Offline Queue] Failed to sync: ${item.type}`, err);
    }
  }
}

export function initOfflineSync(apiClient) {
  window.addEventListener('online', () => {
    console.log('[Offline Queue] Connection restored — syncing...');
    flushQueue(apiClient);
  });
}
